// @flow
import React, { Component } from "react";

import LazyLoad from "react-lazyload";
import s from "./Movie.scss";

export default class Movie extends React.Component {
  constructor(props) {
    super(props);

    this.video = React.createRef();

    this.state = {
      isPlayed: false,
      video: false
    };
  }

  componentDidMount = () => {
    this.setState({ video: this.props.videoURL });
  };

  startMovie = () => {
    this.setState({ isPlayed: true });
    this.video.current.play();
  };

  stopMovie = () => {
    this.setState({ isPlayed: false });
    this.video.current.pause();
  };

  render() {
    return (
      <section className="lp-big__movie">
        <div className="movie-container container"></div>

        <div className="video-box">
          <video
            onClick={() => this.stopMovie()}
            ref={this.video}
            className={"video" + (this.state.isPlayed ? " video-active" : "")}
            name="media"
            loop
          >
            <source src={this.props.videoURL} type="video/mp4" />
          </video>
          <img
            src={this.props.image}
            alt=""
            className={"image" + (this.state.isPlayed ? " hidden" : "")}
          />
          <span
            style={{ display: this.state.isPlayed ? "none" : "block" }}
            onClick={() => this.startMovie()}
            className="af-icon-play-button play-button"
          />
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Movie/Movie.js